<template>
	<!-- Main Sections -->
	<main class="main-wrapper">

			<!-- Title Banner Start -->
			<section class="title-banner">
			<div class="container-fluid">
				<div class="banner-wrapper">
					<img src="/assets/media/banner/left-image.png" alt="" class="banner-image1">
					<h1 class="dark-black fw-600">Новости</h1>
					<img src="/assets/media/banner/right-image.png" alt="" class="banner-image2">
				</div>
			</div>
		</section>
		<!-- Title Banner End -->

		<!-- Blog Section Start -->
		<section class="blog-section bg-lightest-gray py-40">
			<div class="container-fluid">
				<div class="row row-gap-3">
					<div class="col-xl-3 col-md-4" v-for="item in news" :key="item.id">
						<router-link :to="{path: '/news/'+item.id}" class="blog-block bg-white m-0 w-100 h-100">
							<div class="blog-image">
								<img :src="'/'+item.poster" alt="">
							</div>
							<div class="blog-content">
								<div class="d-flex align-items-center gap-16 mb-16">
									<img src="/assets/media/icons/calender.png" alt="">
									<p class="fw-500 dark-black">{{formatDate(item.date, 'DD.MM.YYYY в HH:mm')}}</p>
								</div>
								<h6 class="mb-16 fw-600">{{item.title}}</h6>
								<div class="cus-btn-arrow">Подробнее 
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="none">
										<path d="M13.3545 14.7476C13.3545 11.7476 16.1545 7.74756 19.3545 7.74756M19.3545 7.74756C17.5212 7.74756 13.3545 6.74756 13.3545 0.747559M19.3545 7.74756H0.354492"
											stroke="#0C0C0D" stroke-width="2" />
									</svg>
								</div>                
							</div>
						</router-link>
					</div>
					<div class="pagination mt-24">
						<ul id="border-pagination">
							<li v-if="page > 1">
								<a href="#" @click.prevent="gotoPage(page - 1)">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
										<path d="M9.48438 17.25C9.48438 15 7.38438 12 4.98438 12M4.98438 12C6.35938 12 9.48437 11.25 9.48438 6.75M4.98438 12H19.2344" stroke="#141516" stroke-width="1.5"></path>
									</svg>
								</a>
							</li>
							<li><a href="#" :class="{'active': page == 1}" @click.prevent="gotoPage(page - 1)">1</a></li>
							<li v-if="page - paginationAlpha > 2">
								<span>...</span>
							</li>
							<li v-for="i in range(paginationA1, paginationA2)" :key="i" v-show="paginationA2 >= paginationA1">
								<a href="#" :class="{'active': page == i}" @click.prevent="gotoPage(i)">{{i}}</a>
							</li>
							<li v-if="page + paginationAlpha < getPagesCount() - 1">
								<span>...</span>
							</li>
							<li v-if="getPagesCount() > 1">
								<a href="#" :class="{'active': page == getPagesCount()}" @click.prevent="gotoPage(getPagesCount())">{{getPagesCount()}}</a>
							</li>
							<li v-if="page < getPagesCount()">
								<a href="#" @click.prevent="gotoPage(page + 1)">
									<svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
										<path
											d="M20.1953 22.9995C20.1953 19.9995 22.9953 15.9995 26.1953 15.9995M26.1953 15.9995C24.362 15.9995 20.1953 14.9995 20.1953 8.99951M26.1953 15.9995H7.19531"
											stroke="#282525" stroke-width="2" />
									</svg>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</section>
		<!-- Blog Section End -->
		
		<benefits />
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import Benefits from '@/components/Benefits';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech'});
	},
	data: () => ({
		news: [],
		news_count: 0,
		
		page: 1,
		limit: 8,
		loading: true,
		error: '',
		
		paginationAlpha: 3,
	}),
	computed: {
		paginationA1(){
			return Math.max(this.page - this.paginationAlpha, 2);
		},
		paginationA2(){
			return Math.min(this.page + this.paginationAlpha, this.getPagesCount() - 1);
		},
	},
	methods: {
		formatDate: lib.formatDate,
		range: lib.range,
		
		async loadData(){
			this.loading = true;
			this.error = '';
			const params = {
				start: (this.page - 1) * this.limit,
				limit: this.limit,
			};
			const ret = await this.appModel.doGetNews(params);
			if(ret.success){
				this.news = ret.list;
				this.news_count = ret.count;
			} else {
				this.error = ret.message;
			}
			this.loading = false;
		},
		
		gotoPage(page){
			if(page >= 1 && page <= this.getPagesCount() && page != this.page){
				this.page = page;
				this.loadData();
				window.scrollTo(0, 0);
			}
		},
		// получение количества страниц
		getPagesCount(){
			return Math.ceil(this.news_count / this.limit);
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		await this.loadData();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		Benefits,
	},
};
</script>